import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from 'vue'
import { DcMessage } from '@dc-platform/dc-components'
import { clueApplyPass, clueRejectPass } from '@/api/gucangSales/clueManage'
import type { PotentialItem } from '@/typings/api/customerCenter'

const __default__ = { name: 'transferModel' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const data = ref<PotentialItem[]>([])
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
const editForm = ref<any>({})
const emit = __emit
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { status, auditOpinion, auditRecordIdList } = editForm.value
    try {
      // 通过
      let res
      if (status === '1') {
        res = await clueApplyPass({
          auditOpinion,
          auditRecordIdList
        })
      } else {
        res = await clueRejectPass({
          auditOpinion,
          auditRecordIdList
        })
      }
      DcMessage.success('审核成功')
      emit('success')
      visible.value = false
    } catch (err) {
      console.error(err)
    } finally {
      loading.value = false
    }
  })
}
const toggle = (rows: PotentialItem[]) => {
  if (!rows || !rows.length) {
    DcMessage.warning('请选择数据')
    return
  }
  data.value = rows
  const auditRecordIdList = rows.map((item) => item.recordId)
  const clueIdList = rows.map((item) => item.clueId)
  editForm.value = {
    auditRecordIdList,
    clueIdList,
    status: '1'
  }
  visible.value = true
}

__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
    title: "审批",
    width: "670px",
    onOk: handleSubmit,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: editForm.value,
            ref_key: "formRef",
            ref: formRef
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "clueIdList",
                label: "审核客户",
                rules: [{ required: true, message: '请输入' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: editForm.value.clueIdList,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((editForm.value.clueIdList) = $event)),
                    mode: "multiple",
                    style: {"width":"100%"},
                    disabled: true,
                    options: data.value,
                    fieldNames: { label: 'customerName', value: 'clueId' }
                  }, null, 8, ["value", "options"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "status",
                label: "审批状态",
                rules: [{ required: true, message: '请输入' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio_group, {
                    value: editForm.value.status,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((editForm.value.status) = $event)),
                    name: "radioGroup"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio, { value: "1" }, {
                        default: _withCtx(() => [
                          _createTextVNode("通过")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_radio, { value: "2" }, {
                        default: _withCtx(() => [
                          _createTextVNode("驳回")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "auditOpinion",
                label: "备注",
                rules: [{ required: true, message: '请输入' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CosTextarea, {
                    maxlength: 2000,
                    placeholder: "请输入",
                    value: editForm.value.auditOpinion,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((editForm.value.auditOpinion) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "confirmLoading"]))
}
}

})